import React, { useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import Styles from '../styles/common/pages.module.css';
import Style from '../styles/pages/about-us.module.css';
import { Paper, Typography } from '@mui/material';
import { LazyLoadImage } from 'react-lazy-load-image-component';
// import { useNavigate } from 'react-router-dom';
import AOS from 'aos';

const About: React.FC = () => {
  // const navigate = useNavigate(); // Hook to programmatically navigate

  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration
      once: true, // animation will only happen once
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>About Us - MyShopping App</title>
        <meta
          name="description"
          content="Learn more about My Shopping App and our mission to provide the best online shopping experience."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta property="og:title" content="Home - My Shopping App" />
        <meta
          property="og:description"
          content="Discover the best deals on home goods, kitchenware, clothing, jewelry, and tech gadgets at My Shopping App."
        />
        <meta
          property="og:image"
          content={`${process.env.PUBLIC_URL}/favicon.png`}
        />
        <meta
          property="og:url"
          content="https://mohit-online-shopping.netlify.app/about-us"
        />
      </Helmet>
      {/* Main Heading of the Home Page */}
      <h1 className="visually-hidden">About Us - Online Shopping App & Website</h1>
      {/* This is the First Section of Home Page */}
      <section className={Styles.headSec}>
        <Container>
          <h2>About Us</h2>
        </Container>
      </section>
      <section className={Style.secOne}>
        <Container className='d-flex justify-content-end align-items-center'>
          <Row className='d-flex justify-content-center align-items-center text-left'>

            {/* <Col xs={12} sm={10} md={6} lg={6} className={`justify-content-center align-items-center mb-3 ${Style.glasEffect}`}
            >
              <h3>Our Mission</h3>
              <p>At My Online Shopping, our mission is to simplify your online shopping experience. We curate a wide variety of high-quality products available on Amazon to make it easier for you to find what you need without endless browsing. Our team works tirelessly to bring the best deals, trusted brands, and latest trends right to your fingertips.</p>
            </Col> */}
            <Col xs={12} sm={12} md={12} lg={5} className="mb-3">
              <Paper
                elevation={3}
                className={`${Style.frostedEffect} ${Style.frostedAnimation}`} // Add blur and animation classes
                sx={{
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  backdropFilter: 'blur(5px)',
                  borderRadius: '16px',
                  padding: '20px',
                  boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
                  fontFamily: 'Roboto Slab, serif', // Corrected here
                }}
              >
                <Typography variant="h3" gutterBottom className={Style.headOur}>
                  Our Mission
                </Typography>
                <Typography variant="body1" className={Style.paraOur}>
                  At My Online Shopping Website, our mission is to simplify your online shopping experience.
                  We curate a wide variety of high-quality products available on Amazon to make it easier
                  for you to find what you need without endless browsing. Our team works tirelessly to
                  bring the best deals, trusted brands, and latest trends right to your fingertips.
                </Typography>
              </Paper>
            </Col>
            {/* <Col xs={12} sm={10} md={6} lg={6} className={`justify-content-center align-items-center mt-3 ${Style.imgFluid}`}>
              <img src={`${process.env.PUBLIC_URL}/images/about-us/ourMiss.jpg`} alt="avout us" />
              alt="Our Mission - My Online Shopping" 
            </Col> */}
          </Row>
        </Container>
      </section>
      <section className={Style.secndsec}>
        <Container>
          <Row>
            <Col md={6} className={Style.imageWrapper} data-aos="fade-right" >
              <LazyLoadImage
                src={`${process.env.PUBLIC_URL}/images/about-us/we-are.jpg`} // Public folder se image access
                alt="my shopping app who we are"
                effect="blur" // Add blur effect while loading
                placeholderSrc={`${process.env.PUBLIC_URL}/images/about-us/placeholder-we-are.jpg`} // Use a low-resolution placeholder image
              />{' '}
            </Col>
            <Col md={6} data-aos="fade-left">
              <h3>Who We Are</h3>
              <p>My Online Shopping App is more than just a website—it’s a platform created by passionate individuals who believe in the power of choice and convenience. We understand that finding the perfect product can be overwhelming, which is why we’re here to help you make informed decisions. Every item featured on our site is carefully reviewed to ensure it meets our standards for quality, usability, and value.</p>
            </Col>
          </Row>
        </Container>
      </section>
      <section className={Style.thrdsec}>
        <Container>
          <Row>
            <Col md={6} data-aos="fade-up">
              <h3>Why Choose Us?</h3>
              <p>Our goal is to save you time and offer only the best options from Amazon. We prioritize customer satisfaction and aim to make your online shopping experience smooth, secure, and enjoyable. With a strong focus on quality and customer service, My Online Shopping is dedicated to helping you find products that you’ll love.</p>
            </Col>
            <Col md={6} className={Style.imagechoose} data-aos="fade-down">
              <LazyLoadImage
                src={`${process.env.PUBLIC_URL}/images/about-us/why-choos-us.jpg`} // Public folder se image access
                alt="my shopping app why choose us?"
                effect="blur" // Add blur effect while loading
                placeholderSrc={`${process.env.PUBLIC_URL}/images/about-us/placeholder-why-choos-us.jpg`} // Use a low-resolution placeholder image
              />{' '}
            </Col>
          </Row>
        </Container>
      </section>
      <section className={Style.fourthsec}>
        <Container>
          <Row>
            <Col md={6} className={Style.imagecontct} data-aos="fade-up"
              data-aos-duration="3000">
              <LazyLoadImage
                src={`${process.env.PUBLIC_URL}/images/about-us/contact-us.jpg`} // Public folder se image access
                alt="my shopping app contact us"
                effect="blur" // Add blur effect while loading
                placeholderSrc={`${process.env.PUBLIC_URL}/images/about-us/placeholder-contact-us.jpg`} // Use a low-resolution placeholder image
              />{' '}
            </Col>
            <Col md={6} data-aos="fade-down"
              data-aos-easing="linear"
              data-aos-duration="3000">
              <h3>Contact Us</h3>
              <p>We’re here to help! If you have any questions, suggestions, or feedback, feel free to reach out to us at
                <a style={{ textDecoration: 'none', cursor: 'pointer' }} href="mailto:mahi8191singh@gmail.com">mahi8191singh@gmail.com</a>
                or through our
                {/* <a style={{ textDecoration: 'none', cursor: 'pointer', color: 'blue' }} */}
                {/* // onClick={() => navigate('/contact-us')} // Navigate to /contact-us */}
                {/* > */}
                Contact Us
                {/* </a> */}
                page. We’d love to hear from you and are here to assist you every step of the way.</p>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default About;
